import React, { useEffect } from 'react';
import { PlayArrowRounded } from '@mui/icons-material';
import { JumboBanner } from 'new/elements/JumboBanner';

import styles from './Activity.module.scss';
import { SharedResourcesTo } from 'new/components/SharedResourcesTo';
import { TeamsTable } from 'new/components/TeamsTable';
import { fetchOrgMembers, loadTeams } from 'js/actions';
import { useDispatch } from 'react-redux';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import { useOrgMembers } from 'new/hooks/adapters/useOrgMembers';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_COLLABORATE_DASHBOARD } from 'new/constants/pathnames';
import { useTeams } from 'new/hooks/adapters/useTeams';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { TeamDetailCollaborate } from 'new/components/TeamDetail/TeamDetail';
import { router } from 'new/routes/router';

function Child({ children }) {
  return <div className={styles.container_child}>{children}</div>;
}

export const Activity: ScreenComponent<any> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentUser = useCurrentUser();
  const teams = useTeams();
  const users = useOrgMembers();
  useEffect(() => {
    dispatch(fetchOrgMembers(currentUser?.org?.id));
    dispatch(loadTeams());
  }, []);

  const onClickTeam = (row) => {
    history.push(
      router.manager.getPath(TeamDetailCollaborate.screenConfig.screenName, 'collaborate', [
        row.id,
      ]),
    );
  };
  return (
    <div className={styles.container}>
      <Child>
        <JumboBanner
          title="Collaborate With Your Team Easily"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla morbi nisl pretium fermentum morbi sem ut turpis. Porttitor tincidunt vivamus in id leo nisi, vitae mi. "
          cta={{
            title: 'Learn More',
            startIcon: <PlayArrowRounded />,
            onClick: () => {},
          }}
        />
      </Child>
      <div className={styles.teamsContainer}>
        <Typography variant="subtitle1" className={styles.teamsTitle}>
          Your teams
        </Typography>
        <TeamsTable onClickTeam={onClickTeam} teams={teams} height={300} />
      </div>
      <div className={styles.resources_container}>
        <SharedResourcesTo users={users} />
        <SharedResourcesTo users={users} />
      </div>
    </div>
  );
};

Activity.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE_DASHBOARD}`,
  domain: 'collaborate',
  screenName: 'Dashboard',
};
